import classNames from 'classnames';
import type { FC } from 'react';
import { Icon } from '@reverse-hr/design-system';
import { HINT_ICONS_BY_VARIANT } from '@components/Molecules/SkillsSliderField/_constants/SkillsSliderField.constants';
import type { TSkillsSliderFieldHintProps } from '@components/Molecules/SkillsSliderField/SkillsSliderField.types';

export const SkillsSliderFieldHint: FC<TSkillsSliderFieldHintProps> = ({
  message,
  variant,
}) => {
  const iconName = HINT_ICONS_BY_VARIANT[variant];
  const isIconVisible = !!iconName;

  const iconClassNames = classNames(
    'app-c-skills-slider-field__hint-icon',
    `app-c-skills-slider-field__hint-icon--${variant}`,
  );

  return (
    <>
      {isIconVisible && (
        <Icon className={iconClassNames} name={iconName} size={16} />
      )}

      {message}
    </>
  );
};
